import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../../actions';

import { APIcreatePage } from '../../../api/Pages';

import { userHasFeature } from '../../../helpers/Features';
import { addFlashMessage } from '../../../helpers/FlashMessages';
import { upgradeModalIfNeeded } from '../../../helpers/UpgradePlan';

import UpgradePlanButton from '../../UpgradePlanButton';

const AdminPagesHeader = ({
  history,
  pagesVisible,
  pagesTotal,
  loading,
  openModal,
}) => {
  const intl = useIntl();

  const openCreatePageModal = (e) => {
    if (!userHasFeature('custom-pages') && pagesTotal > 0) {
      upgradeModalIfNeeded('custom-pages', () => {}, e);
    } else {
      openModal({
        className: 'modal-page-create',
        backdrop: 'static',
        initialValues: {
          name: '',
          url: '',
          visibility_mode: 'login_required',
        },
        onConfirm: draft => APIcreatePage({
          name: draft.name,
          url: draft.url,
          visibility_mode: draft.visibility_mode || 'login_required',
          template: draft.template || null,
        }).then((response) => {
          const newPageId = response?.data?.id;

          addFlashMessage({
            type: 'success',
            text: intl.formatMessage({ defaultMessage: 'The new Content Portal has been created' }),
          });

          history.push(`/admin/pages/${newPageId}/edit`);
          return true;
        }),
        onCancel: () => {},
      });
    }
  };

  return (
    <header className="page-header with-upgrade-button">
      <h2 className="page-title">
        <i className="far fa-table-layout" />
        {intl.formatMessage({ defaultMessage: 'Content Portals' })}
      </h2>
      <div className="header-actions users-actions">
        <div className="items-displaying users-displaying">
          {(!loading && pagesTotal > 0) && (
            <span>
              {intl.formatMessage(
                { defaultMessage: `{pagesVisible} of {pagesTotal} pages` },
                { pagesVisible, pagesTotal },
              )}
            </span>
          )}
        </div>
        <div className="button-wrapper custom-pages-button-wrapper ">
          <Button
            color="primary"
            onClick={openCreatePageModal}
          >
            <i className="fas fa-plus" />
            <span>
              {intl.formatMessage({ defaultMessage: 'Create Content Portal' })}
            </span>
            {pagesTotal > 0 && (
              <UpgradePlanButton
                feature="custom-pages"
                flying={true}
                simple={true}
              />
            )}
          </Button>
        </div>
      </div>
    </header>
  );
};

AdminPagesHeader.propTypes = {
  history: PropTypes.object.isRequired,
  pagesVisible: PropTypes.string.isRequired,
  pagesTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  openModal: (params) => {
    dispatch(showModal('AdminPageCreateModal', params));
  },
});

export default withRouter(connect(null, mapDispatchToProps)(AdminPagesHeader));
